import React from 'react'
import classNames from 'classnames'

interface ITabTogglerItemProps {
  id: string
  name: string
  onClick: () => void
  isActive: boolean
  className?: string
}

const TabTogglerItem: React.FC<ITabTogglerItemProps> = ({
  id,
  name,
  isActive,
  onClick,
  className,
}): React.ReactElement => {
  const css = classNames('tab-toggler-item', className, {
    active: isActive,
  })
  return (
    <button
      id={id}
      className={css}
      onMouseDown={(e) => e.preventDefault()} //TODO:: для выключения фокусирования при клике мышкой
      onClick={(e) => {
        e.preventDefault()
        if (onClick) {
          onClick()
        }
      }}>
      <span>{name}</span>
    </button>
  )
}

export {TabTogglerItem}
